import { render } from "./needupload.vue?vue&type=template&id=2342ccc2&scoped=true"
import script from "./needupload.vue?vue&type=script&lang=js"
export * from "./needupload.vue?vue&type=script&lang=js"

import "./needupload.vue?vue&type=style&index=0&id=2342ccc2&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2342ccc2"]])

export default __exports__